/**
 * @flow
 * Created by neo on 20.01.17.
 */

import { observable, computed } from 'mobx';

export default class User {
    @observable id: string;
    @observable email: string;

    constructor(json: any) {
        if(json) {
            this.id = json.id;
            this.email = json.email;
        }
    }

    @computed get isAdmin(): boolean {
        const lower = this.email.toLowerCase();
        return lower === 'jose.rota@bluewin.ch' || lower === 'markus.doebeli@zuehlke.com';
    }
}


// WEBPACK FOOTER //
// ./src/App/Store/User.js